import {decodeToken} from 'react-jwt';
import React from "react";

const withAuth = Component => {
    return class extends React.Component {
        constructor() {
            super();
            this.state = {
                isAuthenticated: false
            };
        }

        componentDidMount() {
            const token = localStorage.getItem('token');

            if (!token) {
                this.setState({ isAuthenticated: false });
                return;
            }

            try {
                const decoded = decodeToken(token);

                if (decoded.exp < Date.now() / 1000) {
                    this.setState({ isAuthenticated: false });
                } else {
                    this.setState({ isAuthenticated: true });
                }
            } catch (error) {
                console.log(error);
                this.setState({ isAuthenticated: false });
            }
        }

        render() {
            return <>{this.state.isAuthenticated ? <Component {...this.props} /> : null}</>;
        }
    };
};

export default withAuth;
